webpackJsonp([162898551421021],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/404.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = PageTemplate;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contentful = __webpack_require__("./src/utils/contentful.js");
	
	var _Page = __webpack_require__("./src/components/Page.js");
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	PageTemplate.propTypes = {
	  data: _propTypes2.default.shape({
	    pages: _propTypes2.default.shape({}).isRequired
	  }).isRequired,
	  location: _propTypes2.default.shape({}).isRequired
	};
	
	function PageTemplate(_ref) {
	  var pages = _ref.data.pages,
	      location = _ref.location;
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: '404 Not Found',
	      pages: (0, _contentful.getNodes)(pages),
	      location: location
	    },
	    _react2.default.createElement(
	      'article',
	      null,
	      'Unfortunately, the page you are looking for does not exist.'
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-bf5cab5bd274aa1bd270.js